"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageCover = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var ImageLoader_1 = require("../ImageLoader");
var ImageCover_st_css_1 = require("./ImageCover.st.css");
exports.ImageCover = function (_a) {
    var src = _a.src, title = _a.title;
    return (React.createElement(ImageLoader_1.ImageLoader, { src: src }, function (_a) {
        var status = _a.status;
        return (React.createElement("div", tslib_1.__assign({ className: ImageCover_st_css_1.st(ImageCover_st_css_1.classes.root, {
                loading: status === ImageLoader_1.ImageStatus.LOADING,
                placeholder: status === ImageLoader_1.ImageStatus.ERROR,
            }) }, (status === ImageLoader_1.ImageStatus.LOADING ? { 'data-src': src } : {}), { "data-hook": "image-cover", title: title, style: {
                backgroundImage: status === ImageLoader_1.ImageStatus.LOADED ? "url(" + src + ")" : undefined,
            } })));
    }));
};
//# sourceMappingURL=ImageCover.js.map